import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this._dirty = false
    this.boundMarkDirty = () => { this._dirty = true }
    this.boundResetDirty = (e) => { if (e.detail?.success) this._dirty = false }
    this.element.addEventListener("input", this.boundMarkDirty)
    this.element.addEventListener("turbo:submit-end", this.boundResetDirty)
  }

  disconnect() {
    this.element.removeEventListener("input", this.boundMarkDirty)
    this.element.removeEventListener("turbo:submit-end", this.boundResetDirty)
  }

  confirmClose() {
    if (this._dirty && !confirm("저장하지 않으면 입력한 내용이 삭제됩니다.\n닫으시겠습니까?")) return
    window.dispatchEvent(new CustomEvent("modals:close"))
  }
}
